// IMPORT LIBS
import jQuery from 'jquery';
import Swiper from 'swiper';
import noUiSlider from 'nouislider';
import bootstrapBundle from '../../../node_modules/bootstrap/dist/js/bootstrap.bundle.js';
import "regenerator-runtime/runtime";

window.$ = jQuery;
window.jQuery = jQuery;
window.Swiper = Swiper;
window.noUiSlider = noUiSlider;
window.bootstrapBundle = bootstrapBundle;

// NEED TO USE "REQUIRE" IN THIS LIBRARY
const fancybox = require('../../../node_modules/@fancyapps/fancybox/dist/jquery.fancybox');
window.fancybox = fancybox;


// IMPORT FUNCTIONS
import { tabsCreate, tabsInit } from './functions/tabs';
import { swipersInit } from './functions/sliders';
import { accordionsCreate, controlAccordionsFilter } from './functions/accordions';
import { showPartialsFixed } from './functions/partialsFixed';
import { buttonCotationBehavior, buttonFilterBehavior } from './functions/actionsForm';
import { showNavbarDropdown } from './functions/dropdowns';
import { sidebarFixedBehavior } from './functions/sidebarFixed';
import { controlDate } from './functions/controlDate';
import { redirectPage } from './functions/redirectPage';
import { handleSetMoreHeight } from './functions/setHeights';
import { chooseUnits } from './functions/chooseLocation';
import { toggleFormCaptation } from './functions/formSetup.js';


document.addEventListener('DOMContentLoaded', function() {

  // FUNCTIONS TO CREATE AND INIT TABS
  tabsCreate();
  tabsInit();

  // FUNCTION TO CREATE AND INIT ACCORDIONS
  accordionsCreate();

  // FUNCTION TO INIT CHOOSE LOCATION
  chooseUnits();

  // FUNCTION TO CREATE AND INIT SWIPERS
  swipersInit();

  // FUNCTION TO CONTROL ACCORDIONS ON USED CARS FILTER
  controlAccordionsFilter();

  // FUNCTION TO CONTROL HEADER/FOOTER FIXED
  window.addEventListener('scroll', () => {
    showPartialsFixed('.header-fixed', 'show-header-scrolled', 'hide-header-scrolled');
    showPartialsFixed('.footer-fixed', 'show-footer-scrolled', 'hide-footer-scrolled');
    showPartialsFixed('.header-mobile.fixed', 'show-header-scrolled', 'hide-header-scrolled');
  });

  // FUNCTION TO CONTROL BEHAVIOR OF COTATION BUTTONS
  buttonCotationBehavior('.button-call-form');
  buttonCotationBehavior('.button-product-cotation');

  // FUNCTION TO CONTROL BEHAVIOR OF FILTERS BUTTONS
  buttonFilterBehavior('.button-call-filter-products');

   // FUNCTION TO CONTROL FORM'S CAPTATION LOCATION
    toggleFormCaptation($('button[data-section]'));

  const unitsSelect = document.querySelector('.units-select');
  if(unitsSelect) {
    showNavbarDropdown('.navbar-link.units-select-dropdown', '.navbar-dropdown-list.units-select-dropdown', 0);
  }

  // FUNCTION TO CONTROL DROPDOWNS ONLY IN NAVBAR MENUS
  showNavbarDropdown('.navbar-link.mega_menu', '.navbar-dropdown-models.modelsDropdown', 0);
  showNavbarDropdown('.navbar-link.simple', '.navbar-dropdown-list.simple', 0);


  // FUNCTION TO CONTROL BEHAVIOR OF SIDEBAR FIXED
  sidebarFixedBehavior('.sidebar');

  // FUNCTION TO INSERT CURRENT DATE IN INPUTS [TYPE=DATE]
  controlDate();

  // FUNCTION TO REDIRECT TO HOME PAGE
  redirectPage();

  // FUNCTION TO SET MORE HEIGHT AMONG THE ELEMENTS OF SAME TYPE
  handleSetMoreHeight('.js-sales-title', 992);
  handleSetMoreHeight('.js-promotion-name', 992);
  handleSetMoreHeight('.js-promotion-desc', 992);
  handleSetMoreHeight('.js-sales-req-title', 992);
  handleSetMoreHeight('.js-sales-req-desc', 992);
  handleSetMoreHeight('.js-sales-available-name', 0);
  handleSetMoreHeight('.js-sales-available-desc', 0);
  handleSetMoreHeight('.js-high-title', 992);
  handleSetMoreHeight('.js-high-desc', 992);

  $('.sidebar-link').click(function(){
    // Seleciona o elemento <i> dentro do botão clicado
    var icon = $(this).find('i');
    // Verifica se o ícone foi encontrado
    if (icon.length) {
      // Adiciona ou remove a classe 'rotate' no ícone para rotacionar
      icon.toggleClass('rotate');
    }
  });

 
  setFamily();
  getModelFromParams();
  changeTestDriveImage();

  $('#form-filter-product, #form-filter-limit-and-order').on('change submit', event => {
    event.preventDefault();
    filterSearchProducts(event.target.form);
  });
  
  $('#btn-busca-produtos').on('click', () => {
    filterSearchProducts(document.getElementById('form-filter-product'));
  });

  $('#input-busca-produtos').on('change', () => {
    if (!$('#input-busca-produtos').val()) {
      let url = new URL(window.location);
      url.searchParams.delete('busca')
      history.pushState({}, "", url);
    }
  });


  function setParams(url, params) {
    Object.entries(params).forEach(([key, value]) => {
      value && url.searchParams.set(key, value);
    });
    history.pushState({}, "", url);
  }
  
  function filterSearchProducts(formSelector) {
    let limit = document.querySelector('#product-limit');
    let page = document.querySelector('#pagination-product-input');
    let sort_order = document.querySelector('#product-order');
    let busca = document.querySelector('#input-busca-produtos');
    const formValues = new FormData(formSelector)
    const url = new URL(window.location);

    limit = limit.value ? limit.value : 12;
    page = page ? page.value : 1;
    sort_order = sort_order ? sort_order.value : '';
    busca = busca ? busca.value : '';

    const filters = {
      limit,page,
      sort_order,busca,
      ...Object.fromEntries(formValues.entries())
    }

    
    setParams(url, filters)
    const objectFilters = Object.fromEntries(url.searchParams.entries())
    $('#listProducts').css('filter', 'blur(5px)');
      $.request('onGetFilterProducts', {
        data: objectFilters,
        loading: '.loader-wrapper',
        complete: () => {
          $('#listProducts').css('filter', 'unset');
        }
    });
   
  }

});


$(document).on('click', '.btn-cotation-modal', function() {
  changeDepartmentAndProduct($(this));
});

function changeDepartmentAndProduct(button) {
  let departmentValue = button.data('department');
  let productValue = button.data('model');
  let departmentSelect = $('select#department');
  let productSelect = $('select#selectedProduct');
  
  if (departmentSelect.find('option:contains("' + departmentValue + '")').length) {
    let findOptionDepartment = departmentSelect.find('option:contains("' + departmentValue + '")');
    findOptionDepartment.prop('selected', true);
  } 
  if (productSelect.find('option[value="' + productValue + '"]').length) {
    let findOptionProduct = productSelect.find('option[value="' + productValue + '"]');
    findOptionProduct.prop('selected', true);
  } else {
    let newOption = $('<option>', {
      value: productValue,
      text: productValue
    });
    productSelect.append(newOption);

    newOption.prop('selected', true);
  }
}



function setFamily(){
  let searchParams = new URLSearchParams(window.location.search);
  const modelname = searchParams.get('modelname');
  const selector = ".my-tabs[data-content='"+modelname+"']";
}

function getModelFromParams() {
  let searchParams = new URLSearchParams(window.location.search);
  const modelname = searchParams.get('modelname');

  if (modelname) {
    $('select#model').val(modelname);
    const imgWrapper = $('form .test-drive-form-img img');

    const img = $('select#model').find('option:selected').attr('data-image');
    imgWrapper.attr('src', img);
  }
}

function changeTestDriveImage() {
  const myInput = $('select#model');
  const imgWrapper = $('form .test-drive-form-img img');
  myInput.on('change', function (e) {
    const img = $(e.target).find('option:selected').attr('data-image');
    imgWrapper.attr('src', img);
  });
}

// FUNCTION TO UP TOP PAGE
$('.btn-scroll-top').on('click', function () {
  $('html,body').animate({ scrollTop: 0 }, '300')
});

// FUNCTION TO ADD OVERLAY ON MODALS
function popUp(selector) {
  $('body,html').addClass('scroll-lock');
  selector.fadeIn('fast');
}

function popClose(form) {
  form ? $('.modal-form').fadeOut() : $('.modal-overlay').fadeOut();
  $('body,html').removeClass('scroll-lock');
  const inputProduct = $('#selectedProduct');
  if(inputProduct) {
    inputProduct.prop('disabled', false);
  }
  
}

// FUNCTION TO PASS INFORMATION TO POP-UP PROMOTIONS
function modalInject(data, target) {
  const { title, img, text } = data;
  $(target).find('.promotion-title').html(title);
  $(target).find('.promotion-img').attr('src', img);
  $(target).find('.promotion-text').html(text);
  popUp($(target));
}

$(document).on('click', '.btn-open-modal', function () {
  const el = $(this).data('target');
  const data = $(this).data('json');
  data ? modalInject(data, el) : popUp($(el));
})

// FUNCTION TO OPEN MODALS
$(document).on('click', '.modal-overlay, .btn-close-modal', function (e) {
  $(e.target).hasClass('form-close') ? popClose() : false
}).on('click', '.pop-up-content', function (event) {
  event.stopPropagation()
})

// FUNCTION TO CONTROL PAGINATIONS
let currentPage = 1;
let currentOrd = 'asc';
let order = 'id';

$('.order-control').on('click', function () {
  search(currentPage);
});

$('.page-link').on('click', function () {

  currentPage = $(this).data('page');
  $('.page-link').removeClass("active");
  $(this).addClass("active");
  search(currentPage);
});

$('.page-link').on('click', function () {
  currentPage = $(this).data('page');
  $('.page-item').removeClass("active");
  $(this.parentElement).addClass("active");

  if (currentPage != "1") {
    $('.left-arrow').removeClass("disabled");
  } else {
    $('.left-arrow').addClass("disabled");
  }

  search(currentPage);
});

function search(pageNum = 1) {
  async function busca() {
    currentOrd = $("#order").val();
    let method = $("#pageId").val();
    let category = $("#category").val();

    if(!order){
    order = 'id'
    }

    if(!currentOrd){
    currentOrd = 'asc'
    }
    
    if(method == 'products'){
      $('#promotions').css('filter', 'blur(5px)');
      const result = await $.request('onGetProducts', {
      data: {order: order,direction : currentOrd, page: pageNum, limit: 9, category: category},
      loading: '.loader-wrapper',
      complete: function(res) {
        $('#promotions').css('filter', 'unset');
      }
      });
      return result;
    }
    

      if(method == 'promotions'){
        const result = await $.request('onGetPromotions', {
        data: {order: currentOrd,page: pageNum, limit: 9},
        complete: function(res) {

        }
        });
        return result;
      }

  }

}
